import { cn } from '@/utils'

export function PlusSignIndicator() {
  return (
    <span
      className={cn(
        'absolute bottom-0 -left-3',
        '-top-[1px]', // Granular adjustment of plus position
        'tabular-nums',
      )}
    >
      +
    </span>
  )
}
